module.exports = __webpack_public_path__ + "static/media/pickup_movil1.d5a6238d.png";